module.exports = __webpack_public_path__ + "a28ccfe006ad5e89e201d277ca739ded.svg";